<template>
  <template v-for="(part, index) of parts" :key="index">
    <code v-if="index % 2" class="ontos-code">{{ part }}</code>
    <template v-else>{{ part }}</template>
  </template>
</template>

<script lang="ts">
import {Component, Prop, Vue, toNative} from 'vue-facing-decorator'

/**
 * Um texto com os nomes de fórmula na fonte de código da casa (`.ontos-code`), marcados com crase,
 * como no markdown: "self é o valor do campo" vira "`self` é o valor do campo" na tradução (pedido do
 * usuário). Crase, e não HTML na tradução com `v-html`: a tradução fica sem marcação nem classe, e
 * nada do texto vira HTML.
 */
@Component({name: 'ontos-code-text'})
class CodeText extends Vue {
  @Prop({type: String, required: true}) readonly text!: string

  /** Os pedaços: os pares são texto, os ímpares, o que estava entre crases. */
  get parts(): string[] {
    return this.text.split('`')
  }
}

export default toNative(CodeText)
</script>
